module.exports = __webpack_public_path__ + "static/media/6.20443be1.svg";